import { useEffect, RefObject } from 'react';

export default function useOnClick<T extends HTMLElement = HTMLDivElement>(
  ref: RefObject<T>,
  onClickOutside: (event: Event) => void,
  onClickInside: (event: Event) => void,
) {
  useEffect(() => {
    const listener = (event: Event) => {
      const el = ref?.current;

      if (!el) {
        return;
      }

      if (el?.contains((event?.target as Node) || null)) {
        onClickInside(event);
        return;
      }
      onClickOutside(event);
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);
    document.addEventListener('keydown', listener);

    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
      document.addEventListener('keydown', listener);
    };
  }, [onClickOutside, onClickInside, ref]);
}
